
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const ArabicInfoPage = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-5xl" dir="rtl">
      <Helmet>
        <title>معلومات | Lainasampo</title>
        <meta name="description" content="معلومات مهمة حول خدمات القروض لدينا والشروط القانونية باللغة العربية." />
      </Helmet>

      <div className="mb-8">
        <h1 className="text-4xl font-bold text-primary mb-4">معلومات مهمة</h1>
        <p className="text-lg text-gray-600">
          تحتوي هذه الصفحة على معلومات مهمة حول خدماتنا والمستندات القانونية باللغة العربية.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">شروط الخدمة</h2>
          <p className="mb-6">
            تشرح شروط الخدمة لدينا شروط استخدام خدمات مقارنة القروض الخاصة بنا،
            بما في ذلك حقوقك ومسؤولياتك.
          </p>
          <Link to="/ar/terms">
            <Button variant="outline" className="w-full">عرض شروط الخدمة</Button>
          </Link>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">سياسة الخصوصية</h2>
          <p className="mb-6">
            توضح سياسة الخصوصية الخاصة بنا كيفية تعاملنا مع معلوماتك الشخصية،
            بما في ذلك ما نجمعه وكيف نستخدمه.
          </p>
          <Link to="/ar/privacy">
            <Button variant="outline" className="w-full">عرض سياسة الخصوصية</Button>
          </Link>
        </div>
      </div>

      <div className="bg-blue-50 p-6 rounded-lg mb-12">
        <h2 className="text-2xl font-bold mb-4">دعم العملاء</h2>
        <p className="mb-4">
          إذا كانت لديك أي أسئلة حول خدماتنا أو تحتاج إلى مساعدة،
          فإن فريق دعم العملاء لدينا متاح لمساعدتك.
        </p>
        <p className="mb-4">
          البريد الإلكتروني: <a href="mailto:info@lainasampo.fi" className="text-primary hover:underline">info@lainasampo.fi</a>
        </p>
        <div className="flex flex-wrap gap-4 mt-6">
          <Link to="/arabic">
            <Button variant="secondary">العودة إلى الصفحة الرئيسية العربية</Button>
          </Link>
          <Link to="/arabic/apply">
            <Button>التقدم بطلب للحصول على قرض</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ArabicInfoPage;
